import Seo from './Seo'

/* Material */
import Container from '@mui/material/Container'
import Typo from '@mui/material/Typography'

import useStyles from './Brands.styles'

/* Types */
import { tBrands } from 'src/shared/frontendTypes/brand'
import type { BreadcrumbItem } from 'src/shared/frontendTypes/product'

/* Components */
import BrandsCarousel from './BrandsCarousel'
import BrandsList from './BrandsList'
import StaticBreadcrumbs from 'src/components/Breadcrumbs/StaticBreadcrumbs'

const breadcrumb: BreadcrumbItem[] = [
  { title: 'Marken' },
]

const Brands = (props:{brands:tBrands}) => {
  const { brands } = props
  const classes = useStyles()

  return <Container maxWidth='lg' className={classes.container}>

    <Seo />
    <StaticBreadcrumbs items={breadcrumb} />

    <Typo component='h1' variant='h4' color='inherit' gutterBottom>
      Unsere Marken
    </Typo>

    <BrandsCarousel {...{brands}} />

    <hr />

    <BrandsList {...{brands}} />

  </Container>

}

export default Brands
